import { render, staticRenderFns } from "./handoutEventFeedbackNotificationItem.vue?vue&type=template&id=2ba01708"
import script from "./handoutEventFeedbackNotificationItem.vue?vue&type=script&lang=ts"
export * from "./handoutEventFeedbackNotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports